import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Validation, ContractType } from '../../models';
import { ErrorMessage, CssClass, Regex } from '../../constants';
import { GtmDatalayerUiService } from '../gtm-datalayer/gtm-datalayer-ui.service';
/*import { isNullOrUndefined } from 'util';*/

@Injectable({
  providedIn: 'root',
})
export class TelephoneValidationService {
  validTelStartDigit: string[] = ['6', '7', '8', '9'];
  constructor(private gtmDataLayerUiService: GtmDatalayerUiService) {}

  telephoneValidSubject: Subject<Validation> = new Subject<Validation>();
  telephoneValid$ = this.telephoneValidSubject.asObservable();
  private error: Validation = new Validation();
  isInValid(contractType: ContractType): boolean {
    let validation = this.telephoneValidation(contractType);
    this.setError(validation);
    return validation.isInValid;
  }
  private telephoneValidation(contractType: ContractType): Validation {
    let validation: Validation = new Validation();
    validation.isInValid = false;
    if (contractType.phone != undefined) {
      let maxlength = contractType.phone.trim().length;
      if (maxlength > 0) {
        if (!(maxlength >= 9) || !this.validateTelephone(contractType.phone)) {
          validation.isInValid = true;
          validation.errorCss = CssClass.error;
          this.gtmDataLayerUiService.setCjError(ErrorMessage.telePhone);
        }
      }
    }

    return validation;
  }
  setError(error: Validation) {
    this.telephoneValidSubject.next(error);
  }
  validateTelephone(telephone) {
    return (
      Regex.telePhone.test(telephone) &&
      this.validTelStartDigit.includes(telephone[0])
    );
  }

  public phoneEmptySubject = new BehaviorSubject<boolean>(true);
  public isPhoneEmpty$ = this.phoneEmptySubject.asObservable();

  public updateEmptyStatus(isEmpty: boolean) {
    this.phoneEmptySubject.next(isEmpty);
  }
}
